import React from 'react'
import NavBar from './components/NavBar.jsx'
import Hero from './components/Hero.jsx'
import Features from './components/Features.jsx'
import Pricing from './components/Pricing.jsx'
import Security from './components/Security.jsx'
import Docs from './components/Docs.jsx'
import Testimonials from './components/Testimonials.jsx'
import Contact from './components/Contact.jsx'
import Footer from './components/Footer.jsx'

export default function App() {
  // localStorage.clear();
  return (
    <div className="font-sans bg-white text-gray-800 overflow-x-hidden">
      <NavBar />
      <Hero />
      <Features />
      <Pricing />
      <Security />
      <Docs />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  )
}
